import { SelectedRecordsState } from 'types';
import { CLEAR_SELECTED_RECORDS, ClearSelectedRecords, UPDATE_SELECTED_RECORDS, UpdateSelectedRecords } from './selectionActions';

export function selectedRecordsReducer(state: SelectedRecordsState = {}, action: UpdateSelectedRecords | ClearSelectedRecords) {
	switch (action.type) {
		case UPDATE_SELECTED_RECORDS: {
			const collection = action.collection;
			const collectionState = state[collection] || {};

			return {
				...state,
				[collection]: {
					...collectionState,
					[action.recordId]: action.selected,
				},
			};
		}
		case CLEAR_SELECTED_RECORDS: {
			const { [action.collection]: _, ...rest } = state;
			return rest;
		}
		default:
			return state;
	}
}
